import getProducer from 'stores/cartStore/services/getProducer'
import { formatDate } from 'utils/formatDate'
import { constantsCart } from './constantsCart'
import { addItem } from './services/addItem'
import { getCart } from './services/getCart'
import { minusItem } from './services/minusItem'
import { plusItem } from './services/plusItem'
import { removeItem } from './services/removeItem'
import { requestQueue } from 'utils/requestsQueue'
import { pricesUpdatedMessage } from 'utils/noStockMessage'
import { setSnackbar } from 'stores/snackbarStore'
import store from 'store'
import { setSectionIsLoading } from 'stores/appStore/actionsApp'

const {
  CART_INIT,
  CART_LOAD,
  CART_ADD_ITEM,
  CART_EDIT_ITEM,
  CART_PLUS_ITEM,
  CART_MINUS_ITEM,
  CART_REMOVE_ITEM,
  CART_EMPTY,
  CART_ADD_CUPON,
  CART_ADD_CUPON_NEW
} = constantsCart

export const getCartItems = (idUsuario, idOrder) => async (dispatch) => {
  requestQueue.addToQueue(async () => {
    try {
      // devuelve 404 si no encuentra el carrito
      const res = await getCart(idUsuario, idOrder)
      if (!res) {
        // Agrega campo openedCart vacio en userInfo del localStorage
        // Deberia crear un redux cart
  
        // const localData = localStorage.getItem('userInfo')
        // if (localData) {
        //   localData.setItem(
        //     'userInfo',
        //     JSON.stringify({ ...JSON.parse(localData), openedCart: '' })
        //   )
        // }
        const newIdOrder = formatDate()
        dispatch({ type: CART_INIT, payload: newIdOrder })
        localStorage.setItem('idOrder', newIdOrder)
        return
      }
      dispatch({ type: CART_LOAD, payload: res })
      localStorage.setItem('idOrder', res?.idOrder)
    } catch (error) {
      console.error(error)
    }
  })
}

export const plusCartItem = (product, order, quantity = 1) => (dispatch) => {
  requestQueue.addToQueue(() => plusItem(product, order))
  dispatch({
    type: CART_PLUS_ITEM,
    payload: {
      [product.tipo]: {
        ...product,
        cantidad: product.cantidad + quantity,
      },
    },
  })
}

export const minusCartItem = (product, order, quantity = 1) => (dispatch) => {
  requestQueue.addToQueue(() => minusItem(product, order))
  dispatch({
    type: CART_MINUS_ITEM,
    payload: {
      [product.tipo]: {
        ...product,
        cantidad: product.cantidad - quantity,
      },
    },
  })
}

export const addItemToCart = (product, order, setLoading) => (
  dispatch
) => {
  requestQueue.addToQueue(async () => {
    try {
      setLoading && setLoading(true)
  
      const { response } = await addItem(product, order)
  
      const productData = { ...response }
      if (productData?.productor && typeof productData?.productor === 'string') {
        const productor = await getProducer(productData?.productor)
        productData.productor = productor
      }
  
      if (productData) {
        productData.descuento = product.descuento;
        dispatch({
          type: CART_ADD_ITEM,
          payload: { [productData.tipo]: productData },
        })
        setLoading && setTimeout(() => setLoading(false), 200)
      }
    } catch (error) {
      setLoading && setTimeout(() => setLoading(false), 200)
      console.log({ error })
    }
  })
}

export const editItemFromCart = (product, order) => (dispatch) => {
  requestQueue.addToQueue(
    async () => {
      await addItem(
          {
            [product.tipo]: {
              ...product,
            },
            updateCartItem: true
          },
          order
        )
    }, 
    () => dispatch(setSectionIsLoading(['cart', false]))
  )

  dispatch({
    type: CART_EDIT_ITEM,
    payload: {
      [product.tipo]: {
        ...product,
      },
    },
  })
}

export const removeItemFromCart = (product) => (dispatch) => {
  let productType
  if (product?.product) productType = 'product'
  if (product?.product_manejo) productType = 'product_manejo'
  if (product?.product_official) productType = 'product_official'

  requestQueue.addToQueue(
    async () => {
      await removeItem(product[productType]?.id)
      dispatch({
        type: CART_REMOVE_ITEM,
        payload: product,
      })
    }
  )
}

export const clearCart = () => (dispatch, getState) => {
  localStorage.removeItem('cuponSelected');
  const newIdOrder = formatDate()
  dispatch({ type: CART_INIT, payload: newIdOrder })
  localStorage.setItem('idOrder', newIdOrder)
}

export const setIdOrder = (newIdOrder) => (dispatch) => {
  if (newIdOrder) {
    localStorage.setItem('idOrder', newIdOrder)
    dispatch({ type: 'CART_SET_ID_ORDER', payload: newIdOrder })
  }
}

export const setCuponDiscount = (cupon) => (dispatch) => {
  if (cupon) {
    dispatch({ type: CART_ADD_CUPON, payload: cupon })
  } else {
    dispatch({ type: CART_ADD_CUPON, payload: null })
  }
}

export const setNewCuponDiscount = (cupon) => (dispatch) => {
  if (cupon) {
    localStorage.setItem('cuponSelected', cupon)
    dispatch({ type: CART_ADD_CUPON_NEW, payload: cupon })
  } else {
    localStorage.removeItem('cuponSelected')
    dispatch({ type: CART_ADD_CUPON_NEW, payload: '' })
  }
}
